
import {Navigate, Route, Routes} from "react-router-dom";

// All layouts containers
import DefaultLayout from "@/layouts/Default";
import VerticalLayout from "@/layouts/Vertical";
import DetachedLayout from "@/layouts/Detached";
import HorizontalLayout from "@/layouts/Horizontal/";
import TwoColumnLayout from "@/layouts/TwoColumn/";

import {
    authProtectedFlattenRoutes,
    publicProtectedFlattenRoutes,
} from "./index";

import {useLayoutContext} from "@/context/useLayoutContext.tsx";
import {useAuthContext} from "@/context/useAuthContext.tsx";
import React from "react";
import { useAppSelector } from "../redux/hooks";
import {routesIndex} from '@/RoutesIndex';
import Error404 from "../pages/error/Error404";


type IRoutesProps = object

const AllRoutes = (props: IRoutesProps) => {
    
    const {isAuthenticated} = useAuthContext()
    const {orientation} = useLayoutContext();

    const getLayout = () => {
        let layoutCls = TwoColumnLayout;

        switch (orientation) {
            case 'horizontal':
                layoutCls = HorizontalLayout;
                break;
            case 'detached':
                layoutCls = DetachedLayout;
                break;
            case 'vertical' :
                layoutCls = VerticalLayout;
                break;
            default:
                layoutCls = TwoColumnLayout;
                break;
        }
        return layoutCls;
    };

    const Layout = getLayout();

    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicProtectedFlattenRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <DefaultLayout {...props}>
                                    {route.element}
                                </DefaultLayout>
                            }
                            key={idx}
                        />
                    ))}
                </Route>

                <Route>
                    {authProtectedFlattenRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                !isAuthenticated ? (
                                    <Navigate
                                        to={{
                                            pathname: routesIndex.app.authentication,
                                            // hash:route.path,
                                            search: "next=" + route.path,
                                        }}
                                    />
                                ) : (
                                    <Layout {...props}>{route.element}</Layout>
                                )
                            }
                            key={idx}
                        />
                    ))}
                </Route>

                {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
                <Route path="*" element={<DefaultLayout><Error404 /></DefaultLayout>} />

            </Routes>
        </React.Fragment>
    );
};

export default AllRoutes;
